export default "__VITE_ASSET__855ef287__"